module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm"
  }, [_vm._v("Of all the benefits")]), _vm._v(" "), _c('p', {
    staticClass: "fm_hang"
  }, [_vm._v("which virtue confers on us,")]), _vm._v(" "), _c('p', {
    staticClass: "fm_hang"
  }, [_vm._v("the contempt of death")]), _vm._v(" "), _c('p', {
    staticClass: "fm_hang"
  }, [_vm._v("is one of the greatest.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_vm._v("—Michel de Montaigne")])]), _vm._v(" "), _c('p', {
    staticClass: "fm_hang"
  }, [_vm._v("Death is watching me.")]), _vm._v(" "), _c('p', {
    staticClass: "fm_hang"
  }, [_vm._v("I am watching her back.")]), _vm._v(" "), _c('p', {
    staticClass: "fm_hang"
  }, [_vm._v("It is a game")]), _vm._v(" "), _c('p', {
    staticClass: "fm_hang"
  }, [_vm._v("at which two can play.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_vm._v("—Mack Bolan, the Executioner")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-561e2c79","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0